// Campus photo for /colleges/colorado-state-university: CC BY-SA 3.0, by Spilly816, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACSU_The_Oval.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/colorado-state-university/; credited under the photo.
const photo = {
    "slug": "colorado-state-university",
    "alt": "Elm trees lining a path across the Oval at Colorado State University in Fort Collins, Colorado",
    "src": "/colleges/colorado-state-university/campus-1600.webp",
    "srcSmall": "/colleges/colorado-state-university/campus-800.webp",
    "srcMid": "/colleges/colorado-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/colorado-state-university/og.jpg",
    "title": "CSU The Oval",
    "author": "Spilly816",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACSU_The_Oval.jpg",
    "read": "2026-10-01"
};

export default photo;
